<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-12-10 17:44:19
 * @FilePath: /mrc-ess-fronted/src/Page/EssAdmin/Claim/ClaimRecord/components/viewClaimItem.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-03-18 14:23:01
-->
<template>
  <normalDialog
    :title="$t('label_essweb_ClaimRecord_form_dialog_viewClaimItemTitle')"
    :dialog="show"
    width="700"
    @close="closeDialog"
    maxWidth="700"
  >
    <template v-slot:content>
      <Taber
        :curTab="curTab"
        @change="(tab) => (curTab = tab)"
        backgroundColor="white"
        :items="taber"
      >
        <template v-slot:content-1>
          <v-form ref="form1" lazy-validation>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <normalInputTextFiled
                  :filled="false"
                  :readonly="true"
                  :value="$getCommonLangValue(Data.claim_item_type_name)"
                  :label="
                    $t(
                      'label_essweb_ClaimRecord_form_dialog_claimItemTypeLabel'
                    )
                  "
                  isNotRequire
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <normalInputTextFiled
                  :filled="false"
                  :readonly="true"
                  :value="$getCommonLangValue(Data.claim_item_name)"
                  :label="
                    $t(
                      'label_essweb_ClaimRecord_form_dialog_claimItemNameLabel'
                    )
                  "
                  isNotRequire
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <normalInputTextFiled
                  :filled="false"
                  :readonly="true"
                  :value="$getDateTime(Data.payout_utc_datetime, 'YYYY/MM/DD')"
                  :label="
                    $t(
                      'label_essweb_ClaimRecord_form_dialog_consumptionDateLabel'
                    )
                  "
                  isNotRequire
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <normalInputTextFiled
                  :filled="false"
                  :readonly="true"
                  :value="$getCommonLangValue(Data.claim_reason_name)"
                  :label="
                    $t('label_essweb_ClaimRecord_form_dialog_claimReasonLabel')
                  "
                  isNotRequire
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <normalInputTextFiled
                  :filled="false"
                  :readonly="true"
                  :value="$getCommonLangValue(Data.claim_item_description)"
                  :label="
                    $t('label_essweb_ClaimRecord_form_dialog_descriptionLabel')
                  "
                  isNotRequire
                />
              </v-col> </v-row
          ></v-form>
        </template>
        <template v-slot:content-2>
          <v-form ref="form2" lazy-validation>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_ClaimRecord_form_dialog_attachmentLabel")
                }}</v-sheet>
                <ImgDragUpdate :defaultImageList="Data.attachments" disabled />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <normalInputTextFiled
                  :filled="false"
                  :readonly="true"
                  :value="Data.receipt_swift_number"
                  :label="
                    $t('label_essweb_ClaimRecord_form_dialog_swiftNumberLabel')
                  "
                  isNotRequire
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <normalInputTextFiled
                  :filled="false"
                  :readonly="true"
                  :value="$getCommonLangValue(Data.cost_center_name)"
                  :label="
                    $t('label_essweb_ClaimRecord_form_dialog_costCentreLabel')
                  "
                  isNotRequire
                />
              </v-col> </v-row
          ></v-form>
        </template>
        <template v-slot:content-3>
          <v-form ref="form3" lazy-validation>
            <v-row>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <normalInputTextFiled
                  :filled="false"
                  :readonly="true"
                  :prefix="Data.actual_currency_code"
                  :suffix="parseFloat(Number(Data.actual_amount)).toString()"
                  :label="
                    $t('label_essweb_ClaimRecord_form_dialog_actualAmountLabel')
                  "
                  isNotRequire
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <normalInputTextFiled
                  :filled="false"
                  :readonly="true"
                  :prefix="Data.claim_currency_code"
                  :suffix="parseFloat(Number(Data.claim_amount)).toString()"
                  :label="
                    $t('label_essweb_ClaimRecord_form_dialog_claimAmountLabel')
                  "
                  isNotRequire
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <normalInputTextFiled
                  :filled="false"
                  :readonly="true"
                  :prefix="Data.approved_currency_code"
                  :suffix="parseFloat(Number(Data.approved_amount)).toString()"
                  :label="
                    $t(
                      'label_essweb_ClaimRecord_form_dialog_approvalAmountLabel'
                    )
                  "
                  isNotRequire
              /></v-col> </v-row
          ></v-form>
        </template>
      </Taber>
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "viewClaimItem",
  computed: {
    ...mapGetters(["defaultUTC"]),
  },
  props: {
    show: { default: false, type: Boolean },
    curUuid: { default: false, type: [Number, String] },
  },
  watch: {
    show(val) {
      if (!val) {
        if (this.$refs["form1"]) this.$refs["form1"].reset();
        if (this.$refs["form2"]) this.$refs["form2"].reset();
        if (this.$refs["form3"]) this.$refs["form3"].reset();
      }
    },
    curUuid(val) {
      if (val) this.getDetail();
    },
  },
  data() {
    return {
      curTab: "tab-1",
      taber: [
        "label_essweb_ClaimRecord_form_dialog_tab_claimItemLabel",
        "label_essweb_ClaimRecord_form_dialog_tab_claimDetailLabel",
        "label_essweb_ClaimRecord_form_dialog_tab_claimAmountLabel",
      ],
      Data: {
        claim_item_type_name: "",
        claim_item_name: "",
        attachments: [],
      },
    };
  },
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_claim_form_record_items",
        url: "/claim-record-items/get-claim-record-items-details/",
        data: {
          uuid: this.curUuid,
        },
      }).then((res) => {
        if (res.data["attachments"])
          res.data["attachments"].map((item) => {
            item["uuid"] = item["uuid"];
            item["file_name"] = item["file_name"];
            item["path"] = item["url"];
            item["size"] = item["attachment_size"];
          });
        that.Data = res.data;
      });
    },
  },
};
</script>